import { useEffect } from 'react';

import { Bus, useApplicationState, useUserMessages } from '@atlas/core';

export const useGetUnreadMessages = () => {
  const { authenticated } = useApplicationState();
  const { clearUserMessages, getUnreadMessages, unreadMessagesCount } = useUserMessages();

  useEffect(() => {
    if (authenticated && !unreadMessagesCount) {
      getUnreadMessages();
    }

    // get unread messages after registration and automatically show popup with messages
    Bus.on(Bus.events.auth.registration, () => {
      getUnreadMessages();
    });

    Bus.on(Bus.events.auth.logout, () => {
      clearUserMessages();
    });
  }, [authenticated, clearUserMessages, getUnreadMessages, unreadMessagesCount]);
};
